import { OnchainAsset } from './onchainTypes';
import { ValuationEngine } from '../../engines/valuationEngine';
// Définition locale pour AggregatedPosition (structure attendue)
export interface AggregatedPosition {
  assetId: string;
  value?: number;
  quantity: number;
  chain: string;
  walletId: string;
  source: string;
  priced: boolean;
}

// Utilise la table interne de prix
let valuationEngine: ValuationEngine | null = null;
export function setValuationEngine(engine: ValuationEngine) {
  valuationEngine = engine;
}

export function normalizeOnchainAssets(assets: OnchainAsset[]): AggregatedPosition[] {
  return assets.map(asset => {
    const price = valuationEngine ? valuationEngine.getPrice(asset.symbol) : undefined;
    return {
      assetId: asset.symbol,
      value: price !== undefined ? asset.quantity * price : undefined,
      quantity: asset.quantity,
      chain: asset.chain,
      walletId: asset.walletId,
      source: 'onchain',
      priced: price !== undefined,
    };
  });
}
